import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';
import { IOrganisation } from '../../Models/Common/Organisation';
import { Global } from '../../Shared/global';

@Component({
  selector: 'app-org-selector',
  templateUrl: './org-selector.component.html',
  styleUrls: ['./org-selector.component.css']
})
export class OrgSelectorComponent implements OnInit {
  organizations: IOrganisation[] = [];
  selectedOrg: IOrganisation | null = null;
  isLoading = false;
  currentUser: any;

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.loadOrganizations();
  }

  /**
   * Load user's organizations
   */
  loadOrganizations(): void {
    const orgsJson = localStorage.getItem('organizations');
    if (orgsJson) {
      this.organizations = JSON.parse(orgsJson);
      if (this.organizations.length > 0) {
        this.selectedOrg = this.organizations[0];
      }
    }
  }

  /**
   * Select organization and navigate
   */
  selectOrganization(org: IOrganisation): void {
    this.selectedOrg = org;
  }

  /**
   * Confirm selection and navigate to dashboard
   */
  confirmSelection(): void {
    if (this.selectedOrg) {
      this.isLoading = true;
      this.authService.selectOrganization(this.selectedOrg);
      setTimeout(() => {
        this.isLoading = false;
        this.router.navigate([Global.DefaultPage]);
      }, 500);
    }
  }

  /**
   * Logout
   */
  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (error) => {
        Global.LogError('Logout error:', error);
        this.router.navigate(['/login']);
      }
    });
  }
}
